
import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import Delivery from "@/components/Delivery/DeliveryView.vue"
import Swal from "sweetalert2";


export default {
    components: {
        HomeNavBar,
        Delivery
    },

    data() {
        return ({
            token_exists: false,
            orders: [],
            user_details: null,
            countdown: '',   // This will store "mm:ss"
            delivery_amount: 0,
            selected_pickup_point: null,
            selected_pickup_point_name: null,
            payfast: process.env.VUE_APP_PAYFAST_URL,
            loading: false,
            cart: [],
            cart_id: this.$route.query.cart,
            order_id: this.$route.query.order,
            cart_item: this.$route.query.cart_item,
            order_exists: false,
            confirming_order: false,
            cart_items: [],
            payment_types: [],
            selected_payment_type: null,
            delivery_method: 'pickup',
            selected_drop_off_point: null,
            default_delivery_amount: 0,
            product_promo_input: "",
            product_promo_message: "",
            product_promo_status: "",
            is_applying_product_promo: false,
            applied_product_promo: null,
            original_order_total_amount: null,
        });
    },
    mounted() {
        this.token_exists = get_token();
        this.user_details = get_user_details();
        if (this.cart_id) {
            this.fetch_cart_details();
        }
        if (this.order_id) {
            this.fetch_cart_order();
        }
        if (this.cart_item) {
            this.fetch_cart_item();
        }
        this.fetch_payment_types();

    },
    computed: {
        total_with_delivery() {
            const subtotal = Number(this.order_total_after_promos || 0);
            return subtotal + this.fulfillment_delivery_amount;
        },
        fulfillment_delivery_amount() {
            if (this.delivery_method !== "delivery") return 0;

            return Number(this.delivery_amount) || this.default_delivery_amount;
        },
       

  order_total_after_promos() {
    const saved_discounted_total = this.get_saved_discounted_total();

    if (saved_discounted_total !== null) return saved_discounted_total;

    return Math.max(this.get_order_original_total() - this.get_order_discount_value(), 0);
  },

  order_discount_amount() {
    const originalTotal = Number(this.orders?.total_amount || 0);
    const discountedTotal = Number(this.order_total_after_promos || 0);

    return Math.max(originalTotal - discountedTotal, 0);
  },

  cart_total() {
    if (!this.cart_items || !this.cart_items.length) return 0;

    return this.cart_items.reduce((sum, item) => {
      return sum + Number((item.product.final_price ?? item.product.price) || 0) * Number(item.quantity || 0);
    }, 0);
  }
},

    methods: {
        getToken() {
            return get_token();
        },
        get_order_original_total() {
            const original_total = this.original_order_total_amount ?? this.orders?.total_amount;

            return Number(original_total || 0);
        },
        get_saved_discounted_total() {
            const saved_total = this.orders?.total_after_discount ?? this.orders?.discounted_total;

            return saved_total === undefined || saved_total === null || saved_total === "" ? null : Number(saved_total);
        },
        get_order_discount_value() {
            const discount_sources = [
                this.orders?.order_promos?.[0]?.total_discount_amount,
                this.applied_product_promo?.discount_amount,
                this.orders?.discount_amount,
            ];
            const discount_value = discount_sources.find((amount) => Number(amount || 0) > 0);

            return Number(discount_value || 0);
        },
        format_attribute_text(value) {
            return String(value || "")
                .trim()
                .split(/[\s_-]+/)
                .filter(Boolean)
                .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
                .join(" ");
        },

        format_date_time(datetime) {
            return new Date(datetime).toLocaleString();
        },
        fetch_payment_types() {

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_payment_types/`,
                method: "GET",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                success: (response) => {
                    this.payment_types = Array.isArray(response?.data) ? response.data : [];
                    if (!this.selected_payment_type && this.payment_types.length) {
                        this.selected_payment_type = this.get_payment_type_value(this.payment_types[0]);
                    }
                },
                error: (xhr) => {

                    console.error("Failed to fetch payment types:", xhr.responseText);
                    this.payment_types = [];
                }
            });
        },

        get_payment_type_value(paymentType) {

            return paymentType?.id || paymentType?.name || null;

        },

        is_payment_type_selected(paymentType) {

            return this.selected_payment_type === this.get_payment_type_value(paymentType);

        },

        select_payment_type(paymentType) {

            this.selected_payment_type = this.get_payment_type_value(paymentType);

        },

        format_currency(amount) {
            const value = Number(amount || 0);
            return `R${value.toLocaleString("en-ZA", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`;
        },
        pick_first_attribute_value(...values) {
            return values.find((value) => value !== undefined && value !== null && value !== '') || '';
        },
        get_attribute_label(attribute) {
            return this.pick_first_attribute_value(
                attribute?.attribute_type?.name,
                attribute?.attribute_type,
                attribute?.name
            );
        },
        get_attribute_value(attribute) {
            return this.pick_first_attribute_value(
                attribute?.label,
                attribute?.value?.value,
                attribute?.value?.name,
                attribute?.value,
                attribute?.attribute_value?.value,
                attribute?.attribute_value?.name
            );
        },
        get_item_attributes(item) {
            const rawAttributes =
                item?.attributes ||
                item?.product_attributes ||
                item?.attribute_values ||
                [];

            if (!Array.isArray(rawAttributes) || !rawAttributes.length) {
                return [];
            }

            return rawAttributes
                .map((attribute) => {
                    const rawLabel = this.get_attribute_label(attribute);
                    const rawValue = this.get_attribute_value(attribute);

                    const label = this.format_attribute_text(rawLabel);
                    const value = this.format_attribute_text(rawValue);

                    if (!label || !value) {
                        return null;
                    }

                    return { label, value };
                })
                .filter(Boolean);
        },

        start_countdown() {
            if (!this.orders || !this.orders.expires_at) return;

            const expireTime = new Date(this.orders.expires_at).getTime();

            this.timer = setInterval(() => {
                const now = new Date().getTime();
                let distance = expireTime - now;

                if (distance <= 0) {
                    clearInterval(this.timer);
                    this.countdown = "Expired";
                    return;
                }

                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                this.countdown = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            }, 1000);
        },
        fetch_cart_details() {
            const cart_id = this.cart_id;
            const user_id = this.user_details.user_id;
            this.loading = true;


            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_cart_for_checkout/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'

                },
                data: JSON.stringify({
                    user_id: user_id,
                    cart_id: cart_id
                }),
                success: (response) => {
                    this.cart = response.cart;
                    this.order_exists = response.order_exists;
                    this.loading = false;
                },
                error: (xhr) => {
                    this.loading = false;
                    console.error("Failed to fetch order:", xhr.responseText);
                },
            });
        },
        confirm_order() {
    Swal.fire({
        title: 'Confirm Order',
        text: 'Your order will be approved first before processing payment.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, confirm order',
        cancelButtonText: 'Cancel',
        position: 'bottom-end',
        toast: true
    }).then((result) => {
        if (result.isConfirmed) {
            this.confirming_order = true;

            const payload = {
                user_id: this.user_details.user_id,
                cart_id: this.cart.id,
                delivery_method: this.delivery_method,
                payment_type: this.selected_payment_type,
            };

            if (this.delivery_method === 'delivery') {
                payload.delivery_amount = Number(this.fulfillment_delivery_amount || 0).toFixed(2);
            }

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/initiate_checkout/`,
                method: 'POST',
                headers: {
                    Authorization: `Token ${get_token()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(payload),
                success: (response) => {
                    this.confirming_order = false;

                    if (response.status === "success") {
                        this.order = response.order;

                        Swal.fire({
                            icon: 'success',
                            title: 'Order Confirmed',
                            text: 'Your order is now pending approval by the seller.',
                            showConfirmButton: false,
                            timer: 1200,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            this.$router.push({ path: '/my_orders' });
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response.message || 'Failed to confirm order.',
                            position: 'bottom-end',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true
                        });
                    }
                },
                error: (xhr) => {
                    this.confirming_order = false;

                    Swal.fire({
                        icon: 'error',
                        title: 'Server Error',
                        text: xhr.responseJSON?.message || xhr.responseJSON?.error || 'Something went wrong. Please try again.',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }
            });
        }
    });
},

        fetch_cart_order() {
            const order_id = this.order_id;
            const user_id = this.user_details.user_id;
            this.loading = true;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_order/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'

                },
                data: JSON.stringify({
                    user_id: user_id,
                    order_id: order_id
                }),
                success: (response) => {

                    this.orders = response.order;
                    this.start_countdown();  // start timer after data is loaded
                    this.loading = false;
                },
                error: (xhr) => {
                    this.loading = false;

                    console.error("Failed to fetch order:", xhr.responseText);
                },
            });
        },

        cancel_order() {
            const order_id = this.$route.params.order_id;
            const user_id = this.user_details.user_id;
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/cancel_order/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'

                },
                data: JSON.stringify({
                    user_id: user_id,
                    order_id: order_id
                }),
                success: () => {
                    this.$router.push({ name: 'home' });

                },
                error: (xhr) => {
                    console.error("Failed to fetch order:", xhr.responseText);
                },
            });
        },

        update_pickup_point(pickup_point) {
            this.selected_pickup_point = pickup_point?.pickup_point_code || null;
            this.selected_pickup_point_name = pickup_point?.pickup_point_name || null;
        },

        select_fulfillment_method(method) {
            this.delivery_method = method;
        },

        proceed_to_payment() {
            const order_id = this.order_id;
            const user_id = this.user_details.user_id;
            const is_pickup = this.delivery_method === "pickup";
            const delivery_amount = Number(this.fulfillment_delivery_amount || 0).toFixed(2);

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_products_payment/`,
                method: 'POST',
                data: JSON.stringify({
                    user_id: user_id,
                    order_id: order_id,
                    payment_type_id: this.selected_payment_type,
                    pickup_point_code: is_pickup ? this.selected_pickup_point : null,
                    pickup_store_name: is_pickup ? this.selected_pickup_point_name : null,
                    delivery_amount: delivery_amount,
                    product_promo_code_id: this.get_applied_product_promo_id(),
                }),
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                success: (response) => {
                    if (response.success) {
                        var data_array = response.data_array;
                        const form = $('#payment_form');
                        for (var [key, value] of Object.entries(data_array)) {
                            var input = $('#input_clone').clone();
                            input.attr('name', key);
                            input.attr('value', value);  // Accessing value without square brackets
                            input.removeAttr('id');
                            input.removeClass('d-none');
                            form.append(input);
                        }

                        Swal.fire({
                            title: 'Success',
                            icon: 'success',
                            text: "Redirecting to PayFast in a few seconds don't close this page",
                            showConfirmButton: false,
                            position: 'bottom-end',
                            timer: 3000,
                            toast: true
                        });

                        form.submit();
                        return;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Payment Error',
                        text: response.message || 'Payment could not be created. Please try again later.',
                        confirmButtonText: 'OK',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                },
                error: (xhr) => {
                    console.error('Failed to create products payment:', xhr.responseText);
                    Swal.fire({
                        icon: 'error',
                        title: 'Payment Error',
                        text: xhr.responseJSON?.message || 'Payment failed. Please try again later.',
                        confirmButtonText: 'OK',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }
            });
        },
        get_product_promo_name(promo) {
            return (
                promo?.promo_code_name ||
                promo?.promo_code?.promo_code_name ||
                promo?.promo_code?.name ||
                promo?.code ||
                ""
            );
        },
        get_product_promo_product_id(promo = this.applied_product_promo) {
            const productIds = this.get_product_promo_product_ids(promo);

            return productIds[0] || null;
        },
        get_product_promo_product_ids(promo = this.applied_product_promo) {
            const product =
                promo?.product ||
                promo?.promo_product ||
                promo?.applicable_product ||
                promo?.product_promo?.product ||
                promo?.promo_code_discount?.product;
            const productIds = promo?.product_ids || promo?.applicable_product_ids || [];

            const resolvedIds = [
                product?.id ||
                promo?.product_id ||
                promo?.promo_product_id ||
                promo?.applicable_product_id ||
                promo?.product_promo?.product_id ||
                promo?.promo_code_discount?.product_id ||
                null,
                ...(Array.isArray(productIds) ? productIds : []),
            ].filter(Boolean);

            return [...new Set(resolvedIds.map((productId) => String(productId)))];
        },
        get_order_item_product_id(item) {
            return item?.product?.id || item?.product_id || null;
        },
        get_product_promo_codes_from_item(item) {
            const promoCodes =
                item?.product?.product_promo_codes ||
                item?.product?.promo_codes ||
                item?.product_promo_codes ||
                item?.promo_codes ||
                [];

            return Array.isArray(promoCodes) ? promoCodes : [];
        },
        is_product_promo_attached_to_item(item) {
            const promo = this.applied_product_promo;
            const promoCodes = this.get_product_promo_codes_from_item(item);
            const promoId = this.get_applied_product_promo_id();
            const promoName = this.get_product_promo_name(promo);

            if (!promoCodes.length || (!promoId && !promoName)) return false;

            return promoCodes.some((productPromo) => {
                const productPromoId =
                    productPromo?.id ||
                    productPromo?.promo_code_discount_id ||
                    productPromo?.promo_code?.id ||
                    null;
                const productPromoName = this.get_product_promo_name(productPromo);

                return (
                    (promoId && String(productPromoId) === String(promoId)) ||
                    (promoName && productPromoName && String(productPromoName).toLowerCase() === String(promoName).toLowerCase())
                );
            });
        },
        is_product_promo_applied_to_item(item) {
            const promoProductIds = this.get_product_promo_product_ids();
            const itemProductId = this.get_order_item_product_id(item);

            if (!promoProductIds.length || !itemProductId) {
                return this.is_product_promo_attached_to_item(item);
            }

            return promoProductIds.includes(String(itemProductId)) || this.is_product_promo_attached_to_item(item);
        },
        get_applied_product_promo_item() {
            return (this.orders?.products || []).find((item) => this.is_product_promo_applied_to_item(item)) || null;
        },
        get_applied_product_promo_product_name() {
            const promo = this.applied_product_promo;
            const promoProduct =
                promo?.product ||
                promo?.promo_product ||
                promo?.applicable_product ||
                promo?.product_promo?.product ||
                promo?.promo_code_discount?.product;
            const orderItem = this.get_applied_product_promo_item();

            return (
                promoProduct?.name ||
                promo?.product_name ||
                promo?.promo_product_name ||
                promo?.applicable_product_name ||
                orderItem?.product?.name ||
                ""
            );
        },
        get_applied_product_promo_id() {
            return this.applied_product_promo?.id || this.applied_product_promo?.promo_code_discount_id || null;
        },
        get_checkout_cart_id() {
            return this.cart_id || this.orders?.cart?.id || this.orders?.cart_id || this.cart?.id || null;
        },
        get_order_product_ids() {
            return (this.orders?.products || [])
                .map((item) => item?.product?.id || item?.product_id)
                .filter(Boolean);
        },
        apply_product_promo() {
            const promo_code_name = String(this.product_promo_input || "").trim();
            const product_ids = this.get_order_product_ids();

            if (!promo_code_name || !product_ids.length || !this.order_id || !this.order_id) return;

            this.is_applying_product_promo = true;
            this.product_promo_message = "";
            this.product_promo_status = "";

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/validate_product_promo_code/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({
                    user_id:this.user_details.user_id,
                    order_id: this.order_id,
                    product_ids,
                    promo_code_name,
                }),
                success: (response) => {
                    if (response.status === "success") {
                        const applied_promo = response.data || null;
                        this.applied_product_promo = applied_promo;
                        this.product_promo_status = "success";
                        this.product_promo_message = response.message || "Promo code applied.";
                    } else {
                        this.applied_product_promo = null;
                        this.product_promo_status = "error";
                        this.product_promo_message = response.message || "Invalid promo code.";
                    }
                },
                error: (xhr) => {
                    this.applied_product_promo = null;
                    this.product_promo_status = "error";
                    this.product_promo_message = xhr?.responseJSON?.message || "Invalid promo code for this order.";
                },
                complete: () => {
                    this.is_applying_product_promo = false;
                },
            });
        },

        fetch_cart_item() {
            const user_id = this.user_details.user_id;
            this.loading = true;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/fetch_cart_item/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify({
                    user_id: user_id,
                    cart_item_id: this.cart_item
                }),
                success: (response) => {
                    if (response.status === "success") {
                        this.cart_items = response.data.item;   // 🔥 normalized cart structure
                    } else {
                        this.cart_items = { items: [] };
                        console.error("Failed to load cart item:", response.message);
                    }

                    this.loading = false;
                },
                error: (xhr) => {
                    this.loading = false;
                    console.error("Failed to fetch cart item:", xhr.responseText);

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Failed to load item for checkout",
                        toast: true,
                        timer: 1500,
                        position: "bottom-end",
                        showConfirmButton: false
                    });
                }
            });
        }
    }
}
